// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","966":"login"}[chunkId] + "." + {"594":"caadbb21","966":"d8d08ca4"}[chunkId] + ".js";
};